/* eslint-disable camelcase */
import { Component } from 'preact';
import PropTypes from 'prop-types';
import Item from './Item';
import ItemPlaceholder from './ItemPlaceholder';
import ButtonLoadMore from './ButtonLoadMore';

class List extends Component {
  componentDidMount() {
    window.matchHeight.match('.list-consortia__list');
  }

  componentDidUpdate() {
    window.matchHeight.match('.list-consortia__list');
  }

  getCardSubtitle(consortiumData) {
    if (!consortiumData) return '';
    const consortiumPlans = consortiumData.my_plans;
    if (consortiumPlans.length === 0) return '';
    return consortiumPlans[0].title;
  }

  vehicleImage(consortiumData) {
    if (!consortiumData) return null;
    const { side_profile_image, item_image } = consortiumData;

    if (side_profile_image) return side_profile_image;
    if (item_image && item_image.middle_image) return item_image.middle_image;

    return null;
  }

  render() {
    const {
      items,
      part_link,
      loading,
      loadingMore,
      showLoadMore,
      onClickButtonLoadMore,
    } = this.props;

    return (
      <div className="list-consortia__list">
        <div className="row">
          {loading &&
            !loadingMore &&
            Array.from({ length: 12 }).map(item => (
              <ItemPlaceholder key={item} />
            ))}

          {items.map((item, index) => (
            <div className="col-md-6 col-lg-4 col-xl-3 list-consortia__item-wrap">
              <Item
                slug={item.slug}
                image={this.vehicleImage(item)}
                model_name={item.title}
                title={item.title}
                version={item.version}
                item_offer={item.item_offer}
                part_link={part_link}
                side_profile_image={item.model.side_profile_image}
                lazyLoading={index > 4}
                subtitle={this.getCardSubtitle(item)}
              />
            </div>
          ))}
        </div>

        {showLoadMore && (
          <div>
            <ButtonLoadMore
              onClick={onClickButtonLoadMore}
              loading={loadingMore}
            />
          </div>
        )}
      </div>
    );
  }
}

List.defaultProps = {
  items: [],
  showLoadMore: false,
  loading: false,
  loadingMore: false,
  onClickButtonLoadMore() {},
  part_link: '',
};

List.propTypes = {
  items: PropTypes.arrayOf,
  showLoadMore: PropTypes.bool,
  loading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  part_link: PropTypes.string,
  onClickButtonLoadMore: PropTypes.func,
};

export default List;
